import type { Account, IntegrationConfig } from '@repo/api-gw-sdk';

import { IntegrationConfiguration } from './integrationConfiguration';
import { IntegrationNameSelection } from './integrationNameSelection';

import type { Step } from '../../wizard/Step';
import type { IntegrationVendor } from '../types';

export type IntegrationWizardState = IntegrationConfig & {
  // UI-specific fields used by the wizard
  vendor: IntegrationVendor;
  // Optional target restore account used by certain integrations (e.g., Redshift)
  restoreAccount?: Account;
  // Optional target vault used by certain integrations (e.g., Redshift)
  vaultId?: string;
};

export const integrationWizardFlow: Step<IntegrationWizardState> = {
  id: 'name_selection',
  Component: IntegrationNameSelection,
  nonReturnable: true,
  next: [
    {
      id: 'integration_configuration',
      Component: IntegrationConfiguration,
    },
  ],
};
